import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RequestCodiceDestinatarioFatturaPRComponent } from './request-codice-destinatario-fattura-pr';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.request-codice-destinatario-fattura-pr', {
            url: '/request-codice-destinatario-fattura-pr',
            ncyBreadcrumb: {
                label: 'Richiesta Codice Destinatario Fattura Privati',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Richiesta Codice Destinatario Fattura Privati'
            },
            'views': {
                'homeContent': {
                    template: '<request-codice-destinatario-fattura-pr flex="100"></request-codice-destinatario-fattura-pr>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RequestCodiceDestinatarioFatturaPRModule: string = ng
    .module('request-codice-destinatario-fattura-pr', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('requestCodiceDestinatarioFatturaPr', RequestCodiceDestinatarioFatturaPRComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/request-codice-destinatario-fattura-pr/request-codice-destinatario-fattura-pr.module.ts